<template>
    <calendar-icon/>
</template>

<script>
const calendarSvg = {
    template: `
<svg width="12" height="11" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2.48047 3.16914C2.68047 3.16914 2.88047 2.96914 2.88047 2.76914V1.26914C2.88047 1.06914 2.68047 0.869141 2.48047 0.869141C2.18047 0.869141 1.98047 1.06914 1.98047 1.26914V2.76914C1.98047 2.96914 2.18047 3.16914 2.48047 3.16914Z" fill="#9B9B9B"/>
    <path d="M8.98047 3.16914C9.18047 3.16914 9.38047 2.96914 9.38047 2.76914V1.26914C9.38047 1.06914 9.18047 0.869141 8.98047 0.869141C8.68047 0.869141 8.48047 1.06914 8.48047 1.26914V2.76914C8.48047 2.96914 8.68047 3.16914 8.98047 3.16914Z" fill="#9B9B9B"/>
    <path d="M10.0809 2.36914H9.78086V2.76914C9.78086 3.16914 9.38086 3.56914 8.98086 3.56914C8.58086 3.56914 8.18086 3.26914 8.18086 2.76914V2.36914H3.28086V2.76914C3.28086 3.16914 2.88086 3.56914 2.48086 3.56914C2.08086 3.56914 1.68086 3.26914 1.68086 2.76914V2.36914H1.28086C0.780859 2.36914 0.380859 2.76914 0.380859 3.16914V9.76914C0.380859 10.2691 0.780859 10.5691 1.28086 10.5691H10.1809H10.2809C10.6809 10.5691 11.0809 10.2691 11.0809 9.86914V9.16914V3.16914C10.9809 2.76914 10.5809 2.36914 10.0809 2.36914ZM1.18086 9.86914V4.66914H10.0809V9.86914H1.18086C1.28086 9.86914 1.18086 9.86914 1.18086 9.86914Z" fill="#9B9B9B"/>
    <path d="M4.08047 7.66895H2.48047V9.16895H4.08047V7.66895Z" fill="#9B9B9B"/>
    <path d="M4.08047 5.36914H2.48047V6.86914H4.08047V5.36914Z" fill="#9B9B9B"/>
    <path d="M8.88125 5.36914H7.28125V6.86914H8.88125V5.36914Z" fill="#9B9B9B"/>
    <path d="M8.88125 7.66895H7.28125V9.16895H8.88125V7.66895Z" fill="#9B9B9B"/>
    <path d="M6.48086 5.36914H4.88086V6.86914H6.48086V5.36914Z" fill="#9B9B9B"/>
    <path d="M6.48086 7.66895H4.88086V9.16895H6.48086V7.66895Z" fill="#9B9B9B"/>
</svg>`
}

const CalendarIcon = {
    template: `
        <a-icon :component="CalendarSvg" />
    `,
    data() {
        return {
            calendarSvg
        }
    }
}
export default {
    components: {
        CalendarIcon
    }
}
</script>

<style>

</style>


